import { render, staticRenderFns } from "./HeroMarquee.vue?vue&type=template&id=13a4c6ce"
import script from "./HeroMarquee.vue?vue&type=script&lang=js"
export * from "./HeroMarquee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports